import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CreditCard, Trash2, Zap } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SavedCardsCard({ refreshKey }) {
  const [cards, setCards] = useState([]);
  const load = () => axios.get(`${API}/pagarme/cards`).then(r => setCards(r.data || [])).catch(() => setCards([]));
  useEffect(() => { load(); }, [refreshKey]);

  const remove = async (id) => {
    if (!window.confirm("Remover este cartão salvo?")) return;
    try { await axios.delete(`${API}/pagarme/cards/${id}`); toast.success("Cartão removido"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro ao remover"); }
  };
  const setDefault = async (id) => {
    try { await axios.post(`${API}/pagarme/cards/${id}/default`); load(); } catch { toast.error("Erro"); }
  };

  return (
    <Card className="p-5" data-testid="saved-cards-card">
      <div className="flex items-center gap-2 mb-3">
        <CreditCard className="w-4 h-4 text-primary" />
        <h3 className="font-bold">Meus cartões</h3>
        <span className="text-xs text-muted-foreground">· pagamento em 1 clique</span>
      </div>
      {cards.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="saved-cards-empty">Nenhum cartão salvo. Ao pagar com cartão, marque "Salvar cartão" para usá-lo nas próximas compras.</p>
      ) : (
        <div className="space-y-2">
          {cards.map(c => (
            <div key={c.card_id} data-testid={`wallet-card-${c.card_id}`} className="flex items-center gap-3 p-3 rounded-xl border">
              <div className="w-10 h-7 rounded bg-gradient-to-br from-slate-700 to-slate-900 text-white flex items-center justify-center text-[10px] font-bold uppercase">{(c.brand || "card").slice(0, 4)}</div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold">•••• {c.last_four} {c.is_default && <span className="ml-1 text-[10px] text-primary font-semibold"><Zap className="w-3 h-3 inline" /> padrão</span>}</div>
                <div className="text-[11px] text-muted-foreground truncate">{c.holder_name} · {String(c.exp_month).padStart(2, "0")}/{String(c.exp_year).slice(-2)}</div>
              </div>
              {!c.is_default && <Button size="sm" variant="ghost" className="text-xs" data-testid={`wallet-card-default-${c.card_id}`} onClick={() => setDefault(c.card_id)}>Tornar padrão</Button>}
              <Button size="icon" variant="ghost" className="text-red-500" data-testid={`wallet-card-remove-${c.card_id}`} onClick={() => remove(c.card_id)} aria-label="Remover"><Trash2 className="w-4 h-4" /></Button>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
